"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProductCategoryId = exports.getProductCategories = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _services = require("./services");

var _constants = _interopRequireDefault(require("./constants"));

var getProductCategories =
/*#__PURE__*/
function () {
  var _ref = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee(mcpSku, onGetAccessToken) {
    var getIDOnly,
        response,
        familyReferenceId,
        _args = arguments;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            getIDOnly = _args.length > 2 && _args[2] !== undefined ? _args[2] : false;
            _context.next = 3;
            return (0, _services.request)("https://introduction.products.cimpress.io/v2/families?skuReferenceId=".concat(mcpSku), onGetAccessToken);

          case 3:
            response = _context.sent;
            familyReferenceId = response && response.length === 1 ? response[0].familyReferenceId : null;
            return _context.abrupt("return", familyReferenceId ? (0, _services.request)("https://introduction.products.cimpress.io/v2/families/".concat(familyReferenceId), onGetAccessToken).then(function (result) {
              if (getIDOnly) {
                return result.categoryId;
              }

              var categories = result.categories;

              if (!categories) {
                categories = [];
              }

              categories = [{
                name: familyReferenceId,
                categoryId: familyReferenceId
              }].concat((0, _toConsumableArray2["default"])(categories));
              categories.forEach(function (category) {
                category.description = 'Current Selection:';
              });
              var rootCategory = categories.find(function (category) {
                return category.categoryId === _constants["default"].CATALOG_ROOT;
              });

              if (!rootCategory) {
                rootCategory = {
                  categoryId: _constants["default"].CATALOG_ROOT
                };
                categories.push(rootCategory);
              }

              rootCategory.name = null;
              rootCategory.description = null;

              if (categories.length > 4) {
                categories.splice(1, categories.length - 4);
              }

              return categories;
            }) : [{
              categoryId: _constants["default"].CATALOG_ROOT
            }]);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getProductCategories(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

exports.getProductCategories = getProductCategories;

var getProductCategoryId =
/*#__PURE__*/
function () {
  var _ref2 = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee2(mcpSku, onGetAccessToken) {
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", getProductCategories(mcpSku, onGetAccessToken, true));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getProductCategoryId(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

exports.getProductCategoryId = getProductCategoryId;